import axios from 'axios';

import { ClassificationStatus } from '../Features/Classification/enum/ClassificationStatus';
import { ClassificationModel } from '../Models/ClassificationModel';
import { CoverPresenceBatchModel } from '../Models/CoverPresenceBatchModel';
import { FilterClassificationModel } from '../Models/FilterClassificationModel';
import { LocationBatchModel } from '../Models/LocationBatchModel';
import baseService from '../shared/baseService';

const classificationService = () => baseService('classifications');

const getClassificationsByFilters = (filter: FilterClassificationModel) => 
    axios.post('classifications/filters', filter);

const deleteBatch = (ids: number[]) => axios.post('classifications/delete-batch', ids);

const updateClassificationStatus = (classificationId: number, classification: ClassificationModel, status: ClassificationStatus) =>
    axios.patch(`classifications/${classificationId}/update-status?status=${status}`, classification);

const updateCoverPresenceBatch = (batch: CoverPresenceBatchModel) => axios.patch(`classifications/${batch.classificationsId[0]}/cover-presences/update-batch`, batch);

const updateLocationBatch = (batch: LocationBatchModel) => axios.patch(`classifications/${batch.classificationsId[0]}/locations/update-batch`, batch);

const insertDetachedClassification = (classification: ClassificationModel, clipperId: number) =>
    axios.post(`classifications/detached?clipperId=${clipperId}`, classification);

export default {
    classificationService,
    getClassificationsByFilters,
    deleteBatch,
    updateClassificationStatus,
    updateCoverPresenceBatch,
    updateLocationBatch,
    insertDetachedClassification
};